import { sortBy, reverse } from "lodash";
import AsyncCallHandler from "../common/AsyncCallHandler";
import NEXUS_CONST from "../common/constants";
import ACTION_TYPES from "./actionTypes";

export const getOPHMissReasonGraph = (dispatch, query) => {
  AsyncCallHandler(
    `digitaltier/GetOPHMissReasonGraph?tierId=${query.tierId}&startDate=${query.startDate}&toDate=${query.endDate}&reasonLevel=${query?.reasonLevel}&rowCount=${query?.rowCount}&isCascaded=${query?.isCascaded}`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.GET_OPH_MISS_REASON_GRAPH,
      payload: reverse(sortBy(res.data, ["missedQty"])) || [],
    });
  });
};

export const fetchOphAttainmentRunChart = (dispatch, payload) => {
  AsyncCallHandler(
    `DigitalTier/OPHRunChart?TierId=${payload.tierId}&Date=${payload.date}`,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_OPH_ATTAINMENT_RUN_CHART,
      payload: res.data,
    });
  });
};

export const exportOphAttainmentData = (payload = null) => {
  const name = payload.isAll
    ? `ophAttainment-all`
    : `ophAttainment_${payload.startDate}_to_${payload.endDate}`;

  AsyncCallHandler(
    `DigitalTier/exportOPHAttainmentDetails?tierId=${payload.tierId}&startDate=${payload.startDate}&endDate=${payload.endDate}&isAll=${payload.isAll}&section=${payload.section}`,
    NEXUS_CONST.POST,
    null,
    NEXUS_CONST.BLOB
  ).then((res) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name + ".xlsx");
    document.body.appendChild(link);
    link.click();
  });
};
